class ProductCarouselTabs extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleTabChange = this.handleTabChange.bind(this)

    this.els.trigger?.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, 'click', this.handleTabChange)
    })
  }

  handleTabChange (event) {
    const clickedTrigger = event.target

    this.els.trigger.elements.forEach((triggerEl) => {
      triggerEl.setAttribute(
        'aria-pressed',
        triggerEl.dataset.index === clickedTrigger.dataset.index,
      )
    })

    this.els.link?.elements.forEach((linkEl) => {
      linkEl.setAttribute(
        'aria-hidden',
        linkEl.dataset.index !== clickedTrigger.dataset.index,
      )
    })

    this.els.panel?.elements.forEach((panelEl) => {
      panelEl.setAttribute(
        'aria-hidden',
        panelEl.dataset.index !== clickedTrigger.dataset.index,
      )
    })
  }
}

if (!customElements.get('product-carousel-tabs')) {
  customElements.define('product-carousel-tabs', ProductCarouselTabs)
}
